import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

type TrailerMapModalProps = {
  open: boolean;
  trailer: any;
  onClose: () => void;
  onTrailerChange: (trailer: any) => void;
  onGetCurrentLocation: () => void;
  onSaveLocation: () => void;
};

const TrailerMapModal: React.FC<TrailerMapModalProps> = ({
  open,
  trailer,
  onClose,
  onTrailerChange,
  onGetCurrentLocation,
  onSaveLocation,
}) => {
  if (!trailer) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Set Location</DialogTitle>

      <DialogContent>
        <Typography variant="h6" align="center" sx={{ mb: 2 }}>
          {trailer.trailer_no}
        </Typography>

        <Stack spacing={2}>
          <TextField
            fullWidth
            label="Longitude"
            value={trailer?.info?.lon || ''}
            onChange={(e) =>
              onTrailerChange({
                ...trailer,
                info: { ...trailer.info, lon: e.target.value },
              })
            }
          />

          <TextField
            fullWidth
            label="Latitude"
            value={trailer?.info?.lat || ''}
            onChange={(e) =>
              onTrailerChange({
                ...trailer,
                info: { ...trailer.info, lat: e.target.value },
              })
            }
          />
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Box sx={{ display: 'flex', gap: 1, width: '100%' }}>
          <Button fullWidth variant="outlined" onClick={onGetCurrentLocation}>
            Get Location
          </Button>
          <Button fullWidth variant="contained" onClick={onSaveLocation}>
            Set Location
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default TrailerMapModal;